import React from "react";
import "./TariffIntro.css";
import introPNG from "../../images/introPNG.png";
const TariffIntro = ({ onChooseStyle, onUploadPhoto, onChooseAddons, onStart }) => {
	const scrollToTariffPlan = () => {
		const tariffPlanElement = document.querySelector('.pricing-title');
		if (tariffPlanElement) {
			tariffPlanElement.scrollIntoView({ 
				behavior: 'smooth',
				block: 'start'
			});
		}
	};

	return (
	  <section className="hero">
      <div className="hero-content">
        <h1 className="hero-title">
          Create bright visual greetings <br /> based on photos
        </h1>

        <div className="hero-options">
          <img src={introPNG} alt="Intro steps" className="hero-options-image" />
        </div>

        <p className="hero-subtext">
          The card will be created by Pryvitai in a minute
        </p>

        <button className="hero-cta" onClick={scrollToTariffPlan}>
          Create greetings
        </button>
      </div>
    </section>
	);
};

export default TariffIntro;

